import React, { useState } from "react";
import Info from "../../assets/info.png";
import Popover from "react-popover";

const InfoPopOver = (props) => {
  const { data } = props;
  const [showInfo, setShowInfo] = useState(false);

  return (
    <Popover
      isOpen={showInfo}
      preferPlace={`below`}
      place={null}
      body={
        <div className="manuar-rx-info">
          By {data?.created_by_user_type} - {data?.created_by}
        </div>
      }
    >
      <img
        src={Info}
        alt=""
        className="ml-2 mb-1"
        style={{ width: "14px" }}
        onMouseOver={() => {
          setShowInfo(true);
        }}
        onMouseOut={() => {
          setShowInfo(false);
        }}
      />
    </Popover>
  );
};

export default InfoPopOver;
